import api from './api'

export function getSso (redirectUrl) {
  return api.get(`/sso?redirectUrl=${redirectUrl}`)
}
